import analyticsReducer from "@store/Store/Data/Analytics/AnalyticsReducer";
import creditInformationsReducer from "@store/Store/Data/CreditInformations/CreditInformationsReducer";
import hideAllPricesModeReducer from "@store/Store/Data/HideAllPricesMode/HideAllPricesModeReducer";
import partsReducer from "@store/Store/Data/Parts/PartsReducer";
import paymentsReducer from "@store/Store/Data/Payment/PaymentsReducer";
import ProductsReducer from "@store/Store/Data/Products/ProductsReducer";
import bulkAddToCartReducer from "@store/Store/Data/QuickOrder/BulkAddToCartReducer";
import quoteToCartReducer from "@store/Store/Data/QuoteToCart/QuoteToCartReducer";
import retailModeReducer from "@store/Store/Data/RetailMode/RetailModeReducer";
import retailModeSettingsReducer from "@store/Store/Data/RetailModeSettings/RetailModeSettingsReducer"; 
import specialPromotionsReducer from "@store/Store/Data/SpecialPromotions/SpecialPromotionsReducer"; 
import { combineReducers } from "redux";

const dataReducers = {
    analytics: analyticsReducer,
    parts: partsReducer,
    retailModeSettings: retailModeSettingsReducer,
    retailMode: retailModeReducer,
    hideAllPricesMode: hideAllPricesModeReducer,
    quoteToCart: quoteToCartReducer,
    payments: paymentsReducer,
    creditInformations: creditInformationsReducer,
    bulkAddToCart: bulkAddToCartReducer,
	products: ProductsReducer,
	specialPromotions: specialPromotionsReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);
export default dataReducer;
